import Chip from "@mui/material/Chip";
import type { GrantLevel } from "@egalregal/shared";
import { useT, type MessageKey } from "../../shared/i18n";

/** Own catalogs report `owner`; shared ones carry their grant level. */
export type CatalogLevel = GrantLevel | "owner";

type LevelColor = "default" | "info" | "warning" | "success";

const LEVEL_KEY: Record<CatalogLevel, MessageKey> = {
  read: "levelRead",
  write: "levelWrite",
  admin: "levelAdmin",
  owner: "levelOwner",
};

const LEVEL_COLOR: Record<CatalogLevel, LevelColor> = {
  read: "default",
  write: "info",
  admin: "warning",
  owner: "success",
};

/** The grant level a catalog row/current block shows. */
export function LevelChip({ level }: { level: CatalogLevel }) {
  const t = useT();
  return (
    <Chip label={t(LEVEL_KEY[level])} size="small" color={LEVEL_COLOR[level]} variant="outlined" />
  );
}
